import React from "react";
import IconGlyph from "@/bit/components/components.icon-glyph";
import PillWithIconFake from "@/components/Fakes/pill-with-icon-fake";
import styles from "./styles";

const MyDataFakeContainer = () => {
  return (
    <>
      <div className="my-data-fake container">
        <div className="my-data-fake--profile-data">
          <div className="my-data-fake--profile-data--icon">
            <IconGlyph id="usuario-l" height="44px" color="white" />
          </div>
          <div className="skeleton my-data-fake--name" />
        </div>
        <div className="my-data-fake--box">
          <div className="info-box-fake">
          <div className="skeleton my-data-fake--title" />
            <PillWithIconFake border />
            <PillWithIconFake border />
            <PillWithIconFake border />
            <PillWithIconFake border />
          </div>
          <div className="info-box-fake">
          <div className="skeleton my-data-fake--title" />
            <PillWithIconFake border />
            <PillWithIconFake border />
            <PillWithIconFake border />
            <PillWithIconFake border />
          </div>
        </div>
      </div>
      <style jsx>{styles}</style>
    </>
  );
};

export default MyDataFakeContainer;
